"use strict";
// (C) 2022 GoodData Corporation
exports.__esModule = true;
exports.valueWithEmptyHandling = void 0;
/**
 * Returns the value if it is non-empty or a fallback text.
 *
 * @param value - value to handle
 * @param emptyValueText - text to display if value is empty
 * @internal
 */
function valueWithEmptyHandling(value, emptyValueText) {
    return value || emptyValueText; // TODO: RAIL-4360 distinguish between empty and null
}
exports.valueWithEmptyHandling = valueWithEmptyHandling;
//# sourceMappingURL=valueWithEmptyHandling.js.map